import React, {useState, useEffect, useContext, useLayoutEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {Passaggio} from '../App'
import '../Citta/Citta.css'

const Citta = () => {
    const [citta, setcitta] = useState([])
    let vettoreCitta=[]
    const link=useNavigate() //UseNavigate per passare da un componente all'altro
    const Contesto = useContext(Passaggio) //Uso il context creato in App.js

    useLayoutEffect(() => {
        setcitta([]);
        ScaricaCitta();
        controllaToken();
    }, [])

const controllaToken=()=>{


    fetch("http://37.60.34.42:8080/contolloToken",{
        method: 'POST',
        headers: {
            'Accept':'application/json',
            'Content-Type':'application/json',
            'Authorization':sessionStorage.getItem("token")
        }
    })
.then(response => response.json())
.then((dati)=>{
    if(dati.risultato=="ko"){
        link("/")
    }
    
})
}

    const passaLocali=(p)=>{
        //Salvo in sessionStorage l'ID della città
        sessionStorage.setItem('idCitta', p)
        //Passo alla pagina dei locali
        link("/locali")
    }

    //Funzione fetch per scaricare città, inserisco le info nel vettore "vettoreCitta"
    //Setto lo stato con il vettore appena riempito
    const ScaricaCitta=()=>{
        let url="http://37.60.34.42:8080/getCitta"
        fetch(url)
        .then(response=>response.json())
        .then(data=>{
            vettoreCitta=[]
            data.forEach(element => {
                vettoreCitta.push(
                <div key={element.id} className='pulsante' onClick={()=>passaLocali(element.id)}>
                    <div className='formattatesto'>{element.citta}</div>
                    <img className='stemma' src={element.stemma}/>
                </div>)
            });
            setcitta(vettoreCitta)
        })
    }

    useEffect(() => {
        ScaricaCitta()
    }, [])
    //visualizzo le citta nel return
    return (
            <div id='cont'>
                {citta}
            </div>
    )
}
export default Citta